import { feathers } from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import io from 'socket.io-client';
import auth from '@feathersjs/authentication-client';

export const host = import.meta.env.VITE_API_URL || 'http://localhost:3030';

const socket = io(host, {
  // transports: ['polling', 'websocket'],
  transports: ['polling'],
  path: import.meta.env.VITE_SOCKET_URL || '/socket.io',
});

const apiClient = feathers()
  .configure(socketio(socket))
  .configure(
    auth({
      storageKey: 'userToken',
    })
  );

export default apiClient;
